import { MouseEvent, useCallback, useMemo, useState } from 'react'
import { Order } from 'Utils/helpers/tables'

export const useTableOrder = <T extends Record<string, unknown>>({
  defaultOrder = 'desc',
  defaultOrderBy = 'date'
}: { defaultOrder?: Order; defaultOrderBy?: keyof T } = {}) => {
  const [order, setOrder] = useState<Order>(defaultOrder)
  const [orderBy, setOrderBy] = useState<keyof T>(defaultOrderBy)

  const resetSortOrder = useCallback(() => {
    setOrderBy('date' as keyof T)
    setOrder('desc')
  }, [])

  const handleRequestSort = useCallback(
    (event: MouseEvent<unknown>, property: keyof T) => {
      const isAsc = orderBy === property && order === 'asc'
      setOrder(isAsc ? 'desc' : 'asc')
      setOrderBy(property)
    },
    [order, orderBy]
  )

  return useMemo(
    () => ({ handleRequestSort, order, orderBy, resetSortOrder }),
    [handleRequestSort, order, orderBy, resetSortOrder]
  )
}
